import { DB_Object_validator, tsValidateResult } from '@nu-art/ts-common';
import { Validator_ModifiableProps } from './db-def.js';
export class BaseVariableWrapper {
    dbVariable;
    constructor(dbVariable) {
        this.dbVariable = dbVariable;
    }
    static getSourceSubTags = (sourceTagId, tagGroups) => {
        if (!sourceTagId || !tagGroups)
            return [];
        return tagGroups?.find(pair => pair.key === sourceTagId && pair.value?.length)?.value || [];
    };
    validate = () => {
        const results = tsValidateResult(this.dbVariable, { ...DB_Object_validator, ...Validator_ModifiableProps });
        if (results) {
            console.error('Save variable validation failed for variable:', this.dbVariable, '\ninvalid:', results);
        }
    };
}
//# sourceMappingURL=wrapper.js.map